module.exports = __webpack_public_path__ + "img/transfer24.e49cbc14.jpeg";